<template>
	<div>
		<form-dialog
			:appendToBody="true"
			:dialogVisible.sync="dialog_visible"
			:formData="formData"
			ref="formData"
			dialogWidth="600px"
			@handleClose="close"
		>
			<dialog-title slot="title" :title="title" :subtitle="subtitle"></dialog-title>
			<dialog-footer
				slot="footer"
				:visible.sync="dialog_visible"
				@confirm="submit"
				@onclose="close"
			></dialog-footer>
		</form-dialog>
	</div>
</template>
<script>
import formDialog from '@/components/webManage/formDialog.vue';
import dialogTitle from '@/components/crm/crm-dialog-title.vue';
import Name from '@/components/crm/crm-form-name.vue';
import dialogFooter from '@/components/crm/crm-dialog-footer.vue';
import customSer from '@/client/services/customerManage/customerSer.js';
import { mapGetters, mapActions } from 'vuex';
import { validRequired } from '@/common/elementValid.js';
export default {
	props: {
		distributeVisible: {
			type: Boolean,
		},
		data: {
			type: Object,
		},
	},
	data() {
		let that = this;
		return {
			title: '分配客户',
			subtitle: '您正在进行公海客户分配操作',
			formData: {
				customerId: {
					displayWith: () => false,
					formType: 'sky-input',
					value: '',
				},
				name: {
					label: '公司名称：',
					formType: Name,
					value: '',
				},
				move: {
					label: '转移至：',
					key: 'targetEmployeeId',
					value: '',
					options: this.getEmployee,
					formType: 'sky-select',
					props: {
						label: 'name',
						value: 'id',
					},
					rules: [validRequired('请选择服务人员', 'change')],
					change(val) {
						if (that.employee && that.employee.length > 0) {
							that.employee.forEach(e => {
								if (e.id == val) {
									that.avatarUrl = e.avatarUrl;
								}
							});
						}
					},
				},
			},
			dialog_visible: false,
			avatarUrl: '',
		};
	},
	watch: {
		distributeVisible: {
			handler() {
				this.dialog_visible = this.distributeVisible;
				this.formData.customerId.value = this.data.customerId;
				this.formData.name.value = this.data.customerName;
			},
		},
	},
	computed: {
		...mapGetters(['chatListData','allChatList']),
	},
	methods: {
		...mapActions(['getEmployeeList']),
		async getEmployee() {
			let employee = await this.getEmployeeList();
			return employee;
		},
		submit() {
			this.$refs.formData.validate(async valid => {
				if (valid) {
					const res = await customSer.distributionCustomer({
						customerId: this.formData.customerId.value,
						targetEmployeeId: this.formData.move.value,
					});
					if (res) {
						this.$message.success(`操作成功`);
						let item;
					if (this.$route.name == 'allChat') {
						item = this.allChatList.find(e => e.id == this.data.customerId);
						this.allChatList.forEach(e => {
							if (e.id == this.data.customerId) {
								e.followupName = this.formData.move.value;
								e.followupHeadPath = this.avatarUrl;
							}
						});
						this.$store.dispatch('setAllChatList', this.allChatList);
					}else{
						item = this.chatListData.find(e => e.id == this.data.customerId);
						this.chatListData.forEach(e => {
							if (e.id == this.data.customerId) {
								e.followupName = this.formData.move.value;
								e.followupHeadPath = this.avatarUrl;
							}
						});
						this.$store.dispatch('setChatListData', this.chatListData);
					}
						this.$emit('changeName', 0);
						this.close();
						this.$router.push({
							name: this.$route.name,
							query: {
								followupName: this.formData.move.value,
								type: item.type,
								id: item.id,
								tableId: item.tableId,
							},
						});
					} else {
						this.$message.info(`操作失败`);
					}
				}
			});
		},
		close() {
			this.dialog_visible = false;
			this.$emit('update:distributeVisible', false);
		},
	},
	components: {
		formDialog,
		dialogTitle,
		// Name,
		dialogFooter,
	},
};
</script>
<style lang="scss" scoped></style>
